export const STATS = {
    all: {
        anchors: 111,
        borrowers: 16527,
        invoices: 221512,
        disbursed: 15278904000,
        aum: 1806839000,
    },
    bnpl: {
        anchors: 22,
        borrowers: 8289,
        invoices: 28236,
        disbursed: 6186841000,
        aum: 310440000,
    },
    vendor: {
        anchors: 5,
        borrowers: 107,
        invoices: 1092,
        disbursed: 3737822000,
        aum: 560864000,
    },
    scf: {
        anchors: 13,
        borrowers: 134,
        invoices: 831,
        disbursed: 5354242000,
        aum: 935536000,
    },
};
